/* @flow */

import {
  SMALL_SIDEBAR_WIDTH,
  REGULAR_SIDEBAR_WIDTH,
} from './sidebar/SideBar.style';

export default {
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    width: `calc(100%-${REGULAR_SIDEBAR_WIDTH + 20}px)`,
    flexDirection: 'row-reverse',
  },
  small: {
    width: `calc(100%-${SMALL_SIDEBAR_WIDTH + 20}px)`,
  },
};
